export default __webpack_public_path__ + "static/media/linkedin-brands.d7833fba.svg";